import React from 'react';
import './index.scss';
export const CheckBox = ({ checked, isDisabled, text, onChange,noFont,disabled,className="", ...rest }) => {
    return (
        <div className={`wrapper check-box__wrapper ${disabled || isDisabled ? "checkbox-disabled" : ""} ${className}`} style={{ display: "flex", alignItems: "center", minHeight: 25 }}>
            <label className="check-box-container" style={{ display: "block", position: "relative", width: 25, height: 25, flexShrink: 0 }}>
                <input type="checkbox"
                    style={{ marginRight: 8 }}
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                    {...rest}
                />
                <span className={isDisabled ? "checkbox-disabled checkbox-checkmark-all" : "checkbox-checkmark"}></span>
            </label>
            {text && <span className="text">{text}</span>}
        </div >
    );
};
